import { render, staticRenderFns } from "./cModalCamposRemi.vue?vue&type=template&id=01176441&scoped=true"
import script from "./cModalCamposRemi.vue?vue&type=script&lang=js"
export * from "./cModalCamposRemi.vue?vue&type=script&lang=js"
import style0 from "./cModalCamposRemi.vue?vue&type=style&index=0&id=01176441&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01176441",
  null
  
)

export default component.exports